// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 12 hooks for backend/refunds.

import { useBackend } from '../useBackend'

/** POST /api/refunds/approveRefund */
export function useApproveRefund<T = any>() {
  return useBackend<T>('refunds/approveRefund')
}

/** POST /api/refunds/getRefundBankDetails */
export function useGetRefundBankDetails<T = any>() {
  return useBackend<T>('refunds/getRefundBankDetails')
}

/** POST /api/refunds/getRefundOptions */
export function useGetRefundOptions<T = any>() {
  return useBackend<T>('refunds/getRefundOptions')
}

/** POST /api/refunds/getRefundSweep */
export function useGetRefundSweep<T = any>() {
  return useBackend<T>('refunds/getRefundSweep')
}

/** POST /api/refunds/getRefunds */
export function useGetRefunds<T = any>() {
  return useBackend<T>('refunds/getRefunds')
}

/** POST /api/refunds/getRefundsAccess */
export function useGetRefundsAccess<T = any>() {
  return useBackend<T>('refunds/getRefundsAccess')
}

/** POST /api/refunds/markRefundPaid */
export function useMarkRefundPaid<T = any>() {
  return useBackend<T>('refunds/markRefundPaid')
}

/** POST /api/refunds/raiseRefund */
export function useRaiseRefund<T = any>() {
  return useBackend<T>('refunds/raiseRefund')
}

/** POST /api/refunds/rejectRefund */
export function useRejectRefund<T = any>() {
  return useBackend<T>('refunds/rejectRefund')
}

/** POST /api/refunds/stageRefundPayment */
export function useStageRefundPayment<T = any>() {
  return useBackend<T>('refunds/stageRefundPayment')
}

/** POST /api/refunds/uploadRefundBankLetter */
export function useUploadRefundBankLetter<T = any>() {
  return useBackend<T>('refunds/uploadRefundBankLetter')
}

/** POST /api/refunds/verifyRefund */
export function useVerifyRefund<T = any>() {
  return useBackend<T>('refunds/verifyRefund')
}
